export const AUXILIARY_ACCOUNT_MUST_HAVE_CENTRALIZER = 'auxiliary_account_must_have_centralizer';

export const PCG_ENTRY_CONSISTENCY_CHECK_CODES = [AUXILIARY_ACCOUNT_MUST_HAVE_CENTRALIZER] as const;

export type PcgEntryConsistencyCheckCodes = (typeof PCG_ENTRY_CONSISTENCY_CHECK_CODES)[number];
